import {
    apiRequest,
    verCheck,
    verVerification
} from "../../../../../services/adapters/kepegawaian/verificationCancelPresensiService"

class IndexRepository {

    fetchCheck = async (query) => {
        return await apiRequest("get", verCheck, {
            params: query
        }, true)
    }

    fetchVerification = async (query) => {
        return await apiRequest("post", verVerification, {
            body: query
        }, true)
    }
    
}

export default IndexRepository